import { createLogic } from 'redux-logic';
import setQffAuthenticationCookie from 'lib/setQffAuthenticationCookie';
import { ssoInitCompleted, ssoLoginSuccess, ssoLogoutSuccess } from '../actions';
import { getSsoUserMemberId, getSsoUserToken } from '../selectors';

const setQffAuthenticationCookieLogic = createLogic({
  type: [ssoInitCompleted, ssoLoginSuccess, ssoLogoutSuccess],
  process({ getState }, _dispatch, done) {
    const state = getState();

    const memberId = getSsoUserMemberId(state);
    const token = getSsoUserToken(state);

    setQffAuthenticationCookie(memberId, token);

    done();
  },
});

export default setQffAuthenticationCookieLogic;
